import { SelectField } from "src/components/FormikComponents/SelectField";
import { isEqual } from "lodash";

interface IDefinitionWeekdaysProps {
  initialValue: number[];
  value: number[];
  onChange: (value: number[]) => void;
  disabled?: boolean;
}

interface IWeekdayOption {
  label: string;
  value: number;
}

const daysOfWeekOptions = [
  { label: "Monday", value: 1 },
  { label: "Tuesday", value: 2 },
  { label: "Wednesday", value: 3 },
  { label: "Thursday", value: 4 },
  { label: "Friday", value: 5 },
  { label: "Saturday", value: 6 },
  { label: "Sunday", value: 7 },
];

const convertValueToOptions = (value: number[]): IWeekdayOption[] => {
  const daysOfWeek: IWeekdayOption[] = [];
  value.forEach((value: number) => {
    const option = daysOfWeekOptions.find((o) => o.value === value);
    daysOfWeek.push(option);
  });
  return daysOfWeek;
};

export const DefinitionWeekdays = (props: IDefinitionWeekdaysProps): JSX.Element => {
  const { initialValue, value, onChange, disabled } = props;
  const isDirty = !isEqual(initialValue, value);

  return (
    <SelectField
      name="definition_daysofweek"
      className={`weekdays_control ${isDirty ? "dirty" : ""}`}
      label="Weekdays"
      isMulti={true}
      onChange={(dow: IWeekdayOption[]) => onChange(dow.map((o) => o.value))}
      value={convertValueToOptions(value)}
      options={daysOfWeekOptions}
      multiMode="checkbox"
      placeholder={`[${value.toString()}]`}
      meta={{
        initialValue: initialValue,
        touched: isDirty,
      }}
      disabled={disabled}
    />
  );
};
